export default "__VITE_ASSET__BLTMTvdw__"